import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, SectionLabel } from "./Reveal";
import { useLang } from "../../i18n";

export const Classifications = () => {
  const { t } = useLang();
  const c = t.classes;
  const [active, setActive] = useState(0);
  const a = c.items[active];

  return (
    <section
      id="classifications"
      data-testid="classifications-section"
      className="relative py-24 sm:py-32 bg-[#060c1f]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionLabel num="[ 03 ]">{c.label}</SectionLabel>
          <h2 className="font-head font-extrabold uppercase tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.9] mb-12 max-w-3xl">
            {c.title1}
            <span className="text-gold-grad">{c.title2}</span>
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 flex flex-col gap-1.5">
            {c.items.map((item, i) => (
              <button
                key={item.cls}
                data-testid={`class-tab-${i}`}
                onClick={() => setActive(i)}
                className={`group text-left rounded-xl border px-5 py-4 transition-all duration-300 ${
                  active === i
                    ? "border-amber-400/60 bg-amber-400/10"
                    : "border-white/10 hover:border-white/25 bg-transparent"
                }`}
              >
                <div className="flex items-center gap-4">
                  <span className={`font-mono-x text-xs ${active === i ? "text-amber-400" : "text-slate-500"}`}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span
                    className={`font-head font-bold uppercase tracking-wide text-lg transition-colors ${
                      active === i ? "text-white" : "text-slate-300 group-hover:text-white"
                    }`}
                  >
                    {item.cls}
                  </span>
                </div>
              </button>
            ))}
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-2xl card-hairline p-8 sm:p-10 h-full min-h-[280px] flex flex-col justify-center relative overflow-hidden">
              <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-blue-600/15 blur-3xl" />
              <AnimatePresence mode="wait">
                <motion.div
                  key={active + a.name}
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -12 }}
                  transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                  data-testid="class-detail"
                >
                  <span className="font-mono-x text-[11px] uppercase tracking-[0.28em] text-amber-400">
                    {a.cls}
                  </span>
                  <h3 className="mt-3 font-head font-extrabold uppercase tracking-tight text-white text-3xl sm:text-4xl leading-tight">
                    {a.name}
                  </h3>
                  <p className="mt-5 text-slate-400 leading-relaxed text-lg max-w-lg">{a.use}</p>
                  <div className="mt-7 flex items-center gap-3 text-sm text-slate-300">
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
                    {c.note}
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
